import { firstValueFrom } from 'rxjs';
import {
  DischargeInfo,
  DischargeInfoDto,
  RequestDto,
} from '../models/request.dto';
import { AuthService } from '../services/auth.service';
import { RequestService } from '../services/request.service';
import { AttachmentService } from '../services/attachment.service';
import { FormDto } from '../models/form.dto';

export async function handleEsitoValutazioneUVMPreSave(
  api: any,
  request: RequestDto,
  requestDates: DischargeInfo[],
    services: { requestService: RequestService; authService: AuthService; attachmentService: AttachmentService },
    form: FormDto,
    compositionId: string,
) {
  const exArt26 = api?.getFieldModel(
    'esito_valutazione_uvm/prestazioni_uvm/riabilitazione/riabilitazione'
  )?.value[0]?.value;

  const rsaRp = api?.getFieldModel(
    'esito_valutazione_uvm/prestazioni_uvm/rsa_rp/rsa_rp'
  )?.value[0]?.value;

  const rsaPsichiatriche = api?.getFieldModel(
    'esito_valutazione_uvm/prestazioni_uvm/valutazione_per_accesso_strutture_riabilitative_psichiatriche/accesso_strutture_riabilitative_psichiatriche'
  )?.value[0]?.value;

  const setting = api?.getFieldValue(
    'generic-boolean-5118598'
  );

  let subsetting = null;
  if(setting) {
    subsetting = '23';
  } else if (exArt26?.length) {
    subsetting = exArt26;
  } else if (rsaPsichiatriche?.length) {
    subsetting = rsaPsichiatriche;
  } else if(rsaRp?.length) {
    subsetting = rsaRp;
  }

  if(subsetting?.length) {
    await firstValueFrom(services.requestService.changeSetting(request.id, subsetting));
  }

  const attachmentCode = api?.getFieldModel(
    'esito_valutazione_uvm/context/paziente/l104_string'
  )?.value[0]?.label;

  const fileName = api?.getFieldModel(
    'esito_valutazione_uvm/context/paziente/nome_allegato'
  )?.value[0];

  const fileContentType = api?.getFieldModel(
    'esito_valutazione_uvm/context/paziente/estensione_allegato'
  )?.value[0];

  const fileuuid = api?.getFieldModel(
    'esito_valutazione_uvm/context/paziente/uuid'
  )?.value[0];
  // const fileuuid = api?.getFieldModel(
  //    'scheda_anamnestica/context/paziente/uuid'
  //  )?.value[0] ? api?.getFieldModel(
  //    'scheda_anamnestica/context/paziente/uuid'
  //  )?.value[0].substring(56,92) : null;

  let requestAttachment = {
    transitionUuid: request.uuid,
    attachmentCode: attachmentCode,
    formId: form.id,
    compositionId: form.compositionId ? form.compositionId : compositionId,
    fileName: fileName,
    fileContentType: fileContentType,
    fileUuid: fileuuid
  }

  await firstValueFrom(
        services.attachmentService.insertAttachmentFromForm(requestAttachment)
  );

  const attachmentCode2 = api?.getFieldModel(
    'esito_valutazione_uvm/prestazioni_uvm/valutazione_per_accesso_strutture_riabilitative_psichiatriche/stringa_allegato_progetto_riabilitativo'
  )?.value[0]?.label;

  const fileName2 = api?.getFieldModel(
    'esito_valutazione_uvm/prestazioni_uvm/valutazione_per_accesso_strutture_riabilitative_psichiatriche/nome_allegato'
  )?.value[0];

  const fileContentType2 = api?.getFieldModel(
    'esito_valutazione_uvm/prestazioni_uvm/valutazione_per_accesso_strutture_riabilitative_psichiatriche/estensione_allegato'
  )?.value[0];

  const fileuuid2 = api?.getFieldModel(
    'esito_valutazione_uvm/prestazioni_uvm/valutazione_per_accesso_strutture_riabilitative_psichiatriche/uuid'
  )?.value[0];
  // const fileuuid = api?.getFieldModel(
  //    'scheda_anamnestica/context/paziente/uuid'
  //  )?.value[0] ? api?.getFieldModel(
  //    'scheda_anamnestica/context/paziente/uuid'
  //  )?.value[0].substring(56,92) : null;

  let requestAttachment2 = {
    transitionUuid: request.uuid,
    attachmentCode: attachmentCode2,
    formId: form.id,
    compositionId: form.compositionId ? form.compositionId : compositionId,
    fileName: fileName2,
    fileContentType: fileContentType2,
    fileUuid: fileuuid2
  }

  await firstValueFrom(
        services.attachmentService.insertAttachmentFromForm(requestAttachment2)
  );

}
